package com.evoapps.evoshift.viewmodels

import com.evoapps.evoshift.domain.comparison.DateRange
import com.evoapps.evoshift.domain.market.Market
import com.evoapps.evoshift.domain.market.payroll.PayrollRules
import com.evoapps.evoshift.domain.model.DailyRecord
import com.evoapps.evoshift.domain.repository.WorkplaceRepository
import com.evoapps.evoshift.domain.usecase.finance.DashboardSalesComparison
import com.evoapps.evoshift.domain.usecase.finance.GetSalesComparisonUseCase
import kotlinx.datetime.LocalDate

/**
 * SH-225: the comparison chips of a month's sales (the week to date against last week, the month
 * to date against last year by weekday), for the dashboard and the Money screen. What was read of
 * last year is kept (by workplace) while the view model lives: the past does not change between
 * two loads, so a reload reads only the recent days.
 */
internal class SalesComparisonChips(
    private val useCase: GetSalesComparisonUseCase?,
    private val workplaces: WorkplaceRepository?
) {
    private var lastYearRead: Triple<String, DateRange, List<DailyRecord>>? = null

    /** [month]'s chips up to [today]; null when they cannot be read (the chips are simply not shown). */
    suspend fun load(workplaceId: String, month: LocalDate, today: LocalDate): DashboardSalesComparison? {
        val useCase = useCase ?: return null
        val settings = workplaces?.getWorkplace(workplaceId)?.getOrNull()?.settings
        val holidays = PayrollRules.of(settings?.market ?: Market.POLAND)
        val cached = lastYearRead?.takeIf { it.first == workplaceId }?.let { it.second to it.third }
        val comparison = useCase.dashboard(workplaceId, month, today, settings?.firstDayOfWeek ?: 1, holidays::isHoliday, cached).getOrNull()
        comparison?.let { lastYearRead = Triple(workplaceId, it.lastYearRange, it.lastYearRecords) }
        return comparison
    }
}
